module.exports = __webpack_public_path__ + "img/gt.bc5b62b6.svg";